import React, { useState } from 'react';

export default function StarButton({ post, isStarred, onToggle, size = 14 }) {
  const [loading, setLoading] = useState(false);
  const [error,   setError]   = useState('');

  const handleClick = async (e) => {
    e.stopPropagation();
    if (loading) return;
    setLoading(true);
    setError('');
    try {
      await onToggle(post);
    } catch (err) {
      setError('Failed');
      setTimeout(() => setError(''), 3000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ position:'relative', display:'inline-flex' }}>
      <button
        onClick={handleClick}
        title={isStarred ? 'Remove star' : 'Star this report'}
        style={{
          background:  'none',
          border:      'none',
          cursor:      loading ? 'wait' : 'pointer',
          padding:     '4px',
          borderRadius: '5px',
          display:     'flex',
          alignItems:  'center',
          justifyContent: 'center',
          opacity:     loading ? 0.5 : 1,
          transition:  'all 0.15s',
          color:       isStarred ? '#BA7517' : 'inherit',
          flexShrink:  0,
        }}
        onMouseEnter={e => { if (!loading) e.currentTarget.style.background = 'rgba(186,117,23,0.12)'; }}
        onMouseLeave={e => { e.currentTarget.style.background = 'none'; }}
      >
        <svg
          width={size} height={size}
          viewBox="0 0 16 16"
          fill={isStarred ? '#BA7517' : 'none'}
          stroke={isStarred ? '#BA7517' : 'currentColor'}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <polygon points="8,1.5 10,6 15,6.5 11.5,10 12.5,15 8,12.5 3.5,15 4.5,10 1,6.5 6,6" />
        </svg>
      </button>
      {error && (
        <div style={{
          position:'absolute', bottom:'-20px', left:'50%',
          transform:'translateX(-50%)',
          fontSize:'8px', color:'#f87171',
          background:'var(--smc-panel, #111)',
          padding:'2px 5px', borderRadius:'3px',
          whiteSpace:'nowrap',
          border:'0.5px solid rgba(248,113,113,0.3)',
          zIndex:10, pointerEvents:'none',
        }}>
          {error}
        </div>
      )}
    </div>
  );
}
